import { ComponentFactoryResolver, Directive, Input, OnInit, ViewContainerRef } from '@angular/core';
import { FormGroup } from '@angular/forms';

/** Form Fields **/
import { InputComponent } from './fields/input.component';
import { EmailComponent } from './fields/email.component';
import { NumberComponent } from './fields/number.component';
import { RadioComponent } from './fields/radio.component';
import { SelectComponent } from './fields/select.component';
import { SubmitComponent } from './fields/submit.component';
import { SwitchComponent } from './fields/switch.component';
import { TextComponent } from './fields/text.component';

const components: any = {
	string: InputComponent,
	text: TextComponent,
	integer: NumberComponent,
	date: InputComponent,
	array: InputComponent,
	bool: SwitchComponent,
	email: EmailComponent,
	json: TextComponent
};

@Directive({
	selector: '[modelField]'
})
export class ModelFieldDirective implements OnInit {

	@Input() map: any;
	@Input() model: any;
	@Input() group: FormGroup;

	component: any;

	constructor(
		private resolver: ComponentFactoryResolver,
		private container: ViewContainerRef
	) { }

	ngOnInit(){
		const comp: any = components[ this.map.type ];
		const factory = this.resolver.resolveComponentFactory<any>( comp );

		this.component = this.container.createComponent( factory );
		this.component.instance.map = this.map;
		this.component.instance.model = this.model;
		this.component.instance.group = this.group;
	}
}
